import PropTypes from "prop-types";
import React, { Component } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import Icon from "@mui/material/Icon";

class AppraiserFilterMenu extends Component {
  constructor() {
    super();
    this.state = {
      isMenuOpen: false,
      anchorEl: null
    };
    this.click = this.click.bind(this);
    this.arrToObj = this.arrToObj.bind(this);

    this.clickAppraiserId = this.clickAppraiserId.bind(this);
    this.toggle = this.toggle.bind(this);
    this.close = this.close.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentWillUnmount() {
    this.toggle = () => { };
  }


  //Stuff Shared with Insurance Filter Menu
  clickAppraiserId(e) {
    this.props.onChange({
      term: "appraiser",
      title: "Appraiser: " + e.currentTarget.innerText,
      code: "id",
      id: e.currentTarget.id
    });
    this.close();
  }

  arrToObj(item) {
    const obj = {onClick: this.click, primaryText: item};
    return obj;
  }
 /////////////////////////////////////////////

  toggle() {
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  }

  close() {
    this.handleClose();
  }

  handleClick(e) {
    this.setState({ anchorEl: e.currentTarget, isMenuOpen: true });
  }

  handleClose() {
    this.setState({ anchorEl: null, isMenuOpen: false });
  }

  click(e) {
    this.props.onChange({
      term: "appraiser",
      title: e.currentTarget.innerText,
      code: e.currentTarget.id,
      id: ""
    });
    this.close();
  }

  render() {
    const { anchorEl, isMenuOpen } = this.state;

    return (
      <>
        <Button onClick={this.handleClick}
          endIcon={<Icon>filter_list</Icon>}
        >
          {this.props.title}
        </Button>
        <Menu
          anchorEl={anchorEl}
          open={isMenuOpen}
          onClose={this.handleClose}
         />
      </>
    );
  }
}

AppraiserFilterMenu.propTypes = {
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  appraiserId: PropTypes.string,
  appraiserName: PropTypes.string
};

export default AppraiserFilterMenu;